import { Controller } from "@hotwired/stimulus"

const ONE_YEAR_IN_SECONDS = 365 * 24 * 60 * 60

// Collapses the admin sidebar to an icon rail. The state lives in a cookie the layout reads,
// so the next page renders collapsed from the server instead of flashing open.
export default class extends Controller {
  static targets = ["toggle"]
  static classes = ["collapsed"]
  static values = { cookie: String, collapseLabel: String, expandLabel: String }

  toggle () {
    this.setCollapsed(!this.collapsed)
  }

  // A submenu title has nothing to show in the rail: open the sidebar on it, with that submenu open.
  // The packs' own click listener on the link has already toggled it, so force it open here.
  openSubmenu (event) {
    const link = event.target.closest(".submenu > a")
    if (!link || !this.collapsed) return

    this.setCollapsed(false)
    link.parentElement.classList.add("toggled")
  }

  setCollapsed (collapsed) {
    this.element.classList.toggle(this.collapsedClass, collapsed)
    document.cookie = `${this.cookieValue}=${collapsed ? 1 : 0}; path=/; max-age=${ONE_YEAR_IN_SECONDS}; SameSite=Lax`

    if (!this.hasToggleTarget) return

    const label = collapsed ? this.expandLabelValue : this.collapseLabelValue
    this.toggleTarget.setAttribute("aria-expanded", String(!collapsed))
    this.toggleTarget.setAttribute("aria-label", label)
    this.toggleTarget.title = label
  }

  get collapsed () {
    return this.element.classList.contains(this.collapsedClass)
  }
}
